import Offcanvas from "react-bootstrap/Offcanvas";
import DocPlaceholder from '../assets/images/document-placeholder.jpg';
import { useEffect, useState } from "react";
import downloadIcon from '../assets/images/download.svg';
import rightIcon from '../assets/images/rightIcon.png';
import leftIcon from '../assets/images/leftIcon.png';
import PdfIcon from '../assets/images/pdf.png';
import XlsIcon from '../assets/images/xls.png';
import DocIcon from '../assets/images/doc.png';

interface propData {
    data: any;
    isShow: boolean;
    isClose: any;
    selectedData: any;
}

const PreviewBlade = (props: propData) => {
    const [currentImage, setCurrentImage] = useState<any>()

    useEffect(() => {
        setCurrentImage(props.selectedData)
    }, [props.isShow])

    const onCloseModal = (e?: any) => {
        props.isClose(!props.isShow, e)
    };

    return (
        <>
            <Offcanvas
                show={props.isShow}
                onHide={onCloseModal}
                placement={"end"}
                className="offcanvas-large"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Media Preview</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="border-bottom px-0 information-main-view ">
                    <div className="px-3 form-style preview-main">
                        <div className="text-center mb-2 d-flex justify-content-end" >
                            <div className="download-button cursor-pointer" onClick={() => window.open(props?.data[currentImage]?.mediaFileURL)}>
                                <img src={downloadIcon} height={22} className="me-2" />
                            </div>
                        </div>
                        <div className="text-center mb-2">{props?.data[currentImage]?.mediaFileDesc}</div>
                        <div className="d-flex w-100" style={{ minWidth: '100%' }}>
                            {<img src={leftIcon} height={50} style={{ marginTop: '40%', opacity: currentImage != 0 ? 1 : 0.2 }} className="cursor-pointer" onClick={() => currentImage != 0 && setCurrentImage(Number(currentImage) - 1)} />}
                            {
                                props?.data[currentImage]?.mediaType == "IMAGE" ?
                                    <img src={props?.data ? props?.data[currentImage]?.mediaFileURL : DocPlaceholder} alt="imag" className="image cursor-pointer" style={{ height: '80vh', width: '80%', objectFit: 'contain' }} />
                                    :
                                    props?.data[currentImage]?.mediaType == "DOC" ?
                                        <span style={{ width: '100%', marginLeft: '20%' }} onClick={() => window.open(props?.data[currentImage]?.mediaFileURL)}>
                                            <img src={DocIcon} alt="imag" className="image cursor-pointer" style={{ height: '10vh', width: '80%', objectFit: 'contain', marginTop: '25vh' }} />
                                        </span>
                                        :
                                        props?.data[currentImage]?.mediaType == "XLS" ?
                                            <span style={{ width: '100%', marginLeft: '20%' }} onClick={() => window.open(props?.data[currentImage]?.mediaFileURL)}>
                                                <img src={XlsIcon} alt="imag" className="image cursor-pointer" style={{ height: '10vh', width: '80%', objectFit: 'contain', marginTop: '25vh' }} />
                                            </span>
                                            :
                                            props?.data[currentImage]?.mediaType == "PDF" ?
                                                <span style={{ width: '100%', marginLeft: '20%' }} onClick={() => window.open(props?.data[currentImage]?.mediaFileURL)}>
                                                    <img src={PdfIcon} alt="imag" className="image cursor-pointer" style={{ height: '10vh', width: '80%', objectFit: 'contain', marginTop: '25vh' }} />
                                                </span>
                                                :
                                                props?.data[currentImage]?.mediaType == "VIDEO" ? <video src={props?.data[currentImage]?.mediaFileURL} controls style={{ height: '80vh', width: '80%', objectFit: 'contain' }} /> :
                                                    <img src={DocPlaceholder} alt="imag" className="image cursor-pointer" style={{ height: '80vh', width: '80%', objectFit: 'contain' }} />
                            }

                            {<img src={rightIcon} height={50} className="cursor-pointer" style={{ marginTop: '40%', opacity: props?.data?.length == (currentImage + 1) ? 0.2 : 1 }} onClick={() => props?.data?.length == (currentImage + 1) ? null : setCurrentImage(Number(currentImage) + 1)} />}
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default PreviewBlade;